"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2857],{

/***/ 72857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_StreamConversation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/LoaderBar.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @keyframes loading {\n    from {\n      left: -200px;\n      width: 30%;\n    }\n    50% {\n      width: 30%;\n    }\n    70% {\n      width: 70%;\n    }\n    80% {\n      left: 50%;\n    }\n    95% {\n      left: 120%;\n    }\n    to {\n      left: 100%;\n    }\n  }\n\n  height: 1px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #dadada;\n  border-radius: 2px 2px 0 0;\n  margin-top: 0;\n  transition: 0.3s ease all;\n\n  :before {\n    display: block;\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: loading 2s linear infinite;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var LoaderBarDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-64e97bca-0"
})(_templateObject());
var LoaderBar = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderBarDiv, {})
    });
};
/* harmony default export */ var Loading_LoaderBar = (LoaderBar);

;// CONCATENATED MODULE: ./src/hooks/useStreamConversationModal.ts

var Screen;
(function(Screen) {
    Screen[Screen["HD_DESKTOP"] = 740] = "HD_DESKTOP";
    Screen[Screen["LAPTOP"] = 660] = "LAPTOP";
    Screen[Screen["TABLET"] = 494] = "TABLET";
})(Screen || (Screen = {}));
function useStreamConversationModal() {
    var ref = (0,react.useState)(window.innerHeight), windowHeight = ref[0], setWindowHeight = ref[1];
    (0,react.useEffect)(function() {
        var handleWindowResize = function() {
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    if (windowHeight > Screen.HD_DESKTOP) {
        return [
            Screen.HD_DESKTOP,
            Screen.HD_DESKTOP
        ];
    }
    if (windowHeight < Screen.LAPTOP) {
        return [
            Screen.TABLET,
            Screen.TABLET
        ];
    }
    return [
        Screen.LAPTOP,
        Screen.LAPTOP
    ];
}
/* harmony default export */ var hooks_useStreamConversationModal = (useStreamConversationModal);

// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/global/Image/index.js
var global_Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(77325);
// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/useDropFile.tsx








var DRAG_AREA_CLASSNAME = "show-drag-area";
var IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp"
];
var DOCUMENT_TYPES = [
    "application/pdf"
];
var MAX_IMAGE_LENGTH = 10;
var isType = function(fileType, types) {
    return types.includes(fileType.toLowerCase());
};
var isImage = function(fileType) {
    return isType(fileType, IMAGE_TYPES);
};
var isDocument = function(fileType) {
    return isType(fileType, DOCUMENT_TYPES);
};
var getImageDimensions = function(file) {
    return new Promise(function(resolved) {
        var i = new Image();
        i.src = file;
        i.onload = function() {
            resolved({
                width: i.width,
                height: i.height
            });
        };
    });
};
function useDropFile(param) {
    var isAllowedToUpload = param.isAllowedToUpload, setDocuments = param.setDocuments, setImages = param.setImages, onErrorMaxSize = param.onErrorMaxSize, images = param.images, documents = param.documents;
    var dropzoneRef = (0,react.useRef)();
    var handleOnDragStart = function(e) {
        e.preventDefault();
        if (isAllowedToUpload) {
            var dropZone = dropzoneRef.current;
            dropZone.classList.add(DRAG_AREA_CLASSNAME);
        }
    };
    var handleOnDragOver = function(e) {
        e.preventDefault();
    };
    var handleOnDrop = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var listDocuments, listImages, dataTransfer, dropZone, arrayDataTransfer, uploadedData, promisesList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        listDocuments = [];
                        listImages = [];
                        if (isAllowedToUpload) {
                            dataTransfer = e.dataTransfer;
                            dataTransfer.dropEffect = "copy";
                            dropZone = dropzoneRef === null || dropzoneRef === void 0 ? void 0 : dropzoneRef.current;
                            dropZone.classList.remove(DRAG_AREA_CLASSNAME);
                            if (e.dataTransfer.files.length !== 0 && e.dataTransfer.items) {
                                arrayDataTransfer = Object.values(e.dataTransfer.items);
                                uploadedData = arrayDataTransfer.length > MAX_IMAGE_LENGTH ? arrayDataTransfer.slice(0, MAX_IMAGE_LENGTH) : arrayDataTransfer;
                                promisesList = [];
                                uploadedData.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                        var process;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (item) {
                                                        process = new Promise(function(resolve, reject) {
                                                            var readerBuffer = new FileReader();
                                                            // @ts-ignore
                                                            var file = item.getAsFile();
                                                            var fileType = file.type, size = file.size;
                                                            var fileSize = size / 1024 / 1024;
                                                            readerBuffer.readAsArrayBuffer(file);
                                                            readerBuffer.onloadend = function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                                                                    var isImageNeverAdded, imagePreviewUrl, dimensions, imageData, deletedExif, isFileNeverAdded;
                                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                                            case 0:
                                                                                if (!isImage(fileType)) {
                                                                                    _ctx.next = 25;
                                                                                    break;
                                                                                }
                                                                                if (!(fileSize > constants/* MAX_IMAGE_SIZE_MB */.Jo)) {
                                                                                    _ctx.next = 5;
                                                                                    break;
                                                                                }
                                                                                {
                                                                                    onErrorMaxSize(true);
                                                                                }
                                                                                _ctx.next = 23;
                                                                                break;
                                                                            case 5:
                                                                                isImageNeverAdded = !((0,_to_consumable_array/* default */.Z)(listImages).concat((0,_to_consumable_array/* default */.Z)(images)).findIndex(function(image) {
                                                                                    return image.fileName === (file === null || file === void 0 ? void 0 : file.name);
                                                                                }) > -1);
                                                                                if (!isImageNeverAdded) {
                                                                                    _ctx.next = 23;
                                                                                    break;
                                                                                }
                                                                                _ctx.next = 9;
                                                                                return URL.createObjectURL(file);
                                                                            case 9:
                                                                                imagePreviewUrl = _ctx.sent;
                                                                                _ctx.next = 12;
                                                                                return getImageDimensions(imagePreviewUrl);
                                                                            case 12:
                                                                                dimensions = _ctx.sent;
                                                                                imageData = {
                                                                                    isNew: true,
                                                                                    type: constants/* IMAGE_TYPE_COMMON */.EZ,
                                                                                    imagePreviewUrl: imagePreviewUrl,
                                                                                    dimensions: dimensions,
                                                                                    fileName: file === null || file === void 0 ? void 0 : file.name
                                                                                };
                                                                                if (!(fileType === "image/jpeg" || fileType === "image/jpg")) {
                                                                                    _ctx.next = 21;
                                                                                    break;
                                                                                }
                                                                                _ctx.next = 17;
                                                                                return (0,utils_image/* deleteImageExif */.T)(event.target.result, fileType);
                                                                            case 17:
                                                                                deletedExif = _ctx.sent;
                                                                                try {
                                                                                    // @ts-ignore
                                                                                    imageData.file = deletedExif;
                                                                                } catch (err) {
                                                                                    imageData.file = file;
                                                                                }
                                                                                _ctx.next = 22;
                                                                                break;
                                                                            case 21:
                                                                                {
                                                                                    imageData.file = file;
                                                                                }
                                                                            case 22:
                                                                                // onChangeImage(imageData);
                                                                                resolve({
                                                                                    type: "image",
                                                                                    data: imageData
                                                                                });
                                                                            case 23:
                                                                                _ctx.next = 26;
                                                                                break;
                                                                            case 25:
                                                                                if (isDocument(fileType)) {
                                                                                    if (fileSize > constants/* MAX_FILE_SIZE_MB */.C1) {
                                                                                        reject(new Error("File too large. The maximum size is ".concat(constants/* MAX_FILE_SIZE_MB */.C1, "MB")));
                                                                                    } else {
                                                                                        isFileNeverAdded = !((0,_to_consumable_array/* default */.Z)(documents).concat((0,_to_consumable_array/* default */.Z)(listDocuments)).findIndex(function(document) {
                                                                                            return document.name === (file === null || file === void 0 ? void 0 : file.name);
                                                                                        }) > -1);
                                                                                        if (isFileNeverAdded) {
                                                                                            // onChangeDocument(file);
                                                                                            resolve({
                                                                                                type: "document",
                                                                                                data: file
                                                                                            });
                                                                                        }
                                                                                    }
                                                                                }
                                                                            case 26:
                                                                            case "end":
                                                                                return _ctx.stop();
                                                                        }
                                                                    }, _callee);
                                                                }));
                                                                return function(event) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }();
                                                        });
                                                        promisesList.push(process);
                                                    }
                                                case 1:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                Promise.all(promisesList).then(function(res) {
                                    // eslint-disable-next-line array-callback-return
                                    res.map(function(item) {
                                        if (item.type === "image") {
                                            listImages.push(item.data);
                                        }
                                        if (item.type === "document") {
                                            if (listDocuments.length < 1) {
                                                listDocuments.push(item.data);
                                            } else {
                                                throw new Error(errorMessage/* default.MAX_UPLOAD_FILES */.Z.MAX_UPLOAD_FILES);
                                            }
                                        }
                                    });
                                }).then(function() {
                                    setDocuments(function(prev) {
                                        return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(listDocuments));
                                    });
                                    if (listImages.length === 1) {
                                        setImages(function(prev) {
                                            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(listImages));
                                        });
                                    }
                                }).catch(function(err) {
                                    (0,AlertMessage/* default */.Z)({
                                        content: err.message,
                                        alertType: "plain-default",
                                        messageType: "error",
                                        hasCloseIcon: false
                                    });
                                });
                            }
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnDrop(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        dropzoneRef: dropzoneRef,
        handleOnDragStart: handleOnDragStart,
        handleOnDragOver: handleOnDragOver,
        handleOnDrop: handleOnDrop
    };
}
/* harmony default export */ var ComposeConversation_useDropFile = (useDropFile);

// EXTERNAL MODULE: ./src/lib/entities/user.js
var user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/global/StreamCompose/styled.ts
var styled = __webpack_require__(94134);
// EXTERNAL MODULE: ./node_modules/antd/es/mentions/index.js + 7 modules
var mentions = __webpack_require__(46457);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 60px;\n    bottom: 0px;\n    form {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      \n    }\n\n    @media ",
        " {\n      form {\n        height: auto;\n        flex-direction: column;\n        justify-content: flex-end;\n      }\n    }\n  "
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 0;\n  // TODO : Add Color to @stockbit/ui\n  border-top: 1px solid #f1f1f1;\n  background-color: ",
        ";\n  width: 100%;\n  \n  .show-drag-area {\n    border-style: dashed;\n    border-width: 2px;\n    border-color: ",
        ";\n  }\n\n  @media ",
        " {\n    position: relative;\n    top: unset !important;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none !important;\n  box-shadow: none !important;\n  font-family: 'ProximaNovaRg';\n  margin-bottom: 12px;\n  margin-top: 10px;\n  resize: none;\n  width: 100%;\n\n  textarea {\n    padding: 0;\n  }\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n      flex: 1 0 90%;\n      max-height: 600px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 200px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  max-height: 200px;\n  overflow: scroll;\n  margin-left: 10px;\n\n  @media ",
        " {\n    max-height: 340px;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 10px;    \n  padding: 0 20px;\n\n  @media ",
        " {\n    position: relative;\n    bottom: unset;\n    padding: 0px 20px 15px 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  height: 200px;\n  max-height: 200px;\n  background: ",
        ";\n  overflow: hidden;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n      height: auto;\n      align-self: center;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: initial;\n  object-fit: cover;\n  object-position: 50% 50%;\n  height: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  border-radius: 100%;\n  background: ",
        "",
        ";\n  padding: 5px;\n  cursor: pointer;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px; \n  font-weight: bold;\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 25px;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding: 0;\n  @media ",
        " {\n    position: relative;\n    bottom: unset;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 25px;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding: 20px 20px 10px 20px;\n  @media ",
        " {\n    position: relative;\n    bottom: unset;\n    padding: 20px 20px 0px 20px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    .ant-mentions-dropdown {\n      left: 70px !important;\n    }\n    .ant-mentions-dropdown-menu-item {\n      border-bottom: 1px solid #f5f6f5;\n      height: 30px;\n      padding: 0 12px;\n\n      & > div {\n        height: 30px;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-active {\n       p {\n        font-family: var(--font-bold) !important;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-disabled {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 8px;\n  > img {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}




var Flex = ui/* Common.Flex */.Gn.Flex, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var percentToHex = ui/* utils.hexOpacity */.P6.hexOpacity;
var ReplyCompose = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-0"
})(_templateObject1(), ui/* color.light */.$_.light, ui/* color.primary */.$_.primary, ui/* device.tablet */.Uh.tablet, function(param) {
    var isExpand = param.isExpand;
    return isExpand && (0,styled_components_browser_esm.css)(styled_templateObject(), ui/* device.tablet */.Uh.tablet);
});
var TextareaMentions = (0,styled_components_browser_esm["default"])(mentions/* default */.Z).attrs(function(props) {
    return {
        placeholder: props.placeholder || "Write your comment here...",
        autoSize: props.autoSize || {
            minRows: 3
        }
    };
}).withConfig({
    componentId: "sc-786a9936-1"
})(_templateObject2());
var ComposeContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-2"
})(_templateObject5(), ui/* device.tablet */.Uh.tablet, function(param) {
    var isExpand = param.isExpand;
    return isExpand && (0,styled_components_browser_esm.css)(_templateObject3());
}, function(param) {
    var isFooterExpanded = param.isFooterExpanded;
    return isFooterExpanded && (0,styled_components_browser_esm.css)(_templateObject4());
});
var FooterComposeWrapper = (0,styled_components_browser_esm["default"])(Flex).attrs({
    align: "center",
    justify: "space-between",
    width: "100%"
}).withConfig({
    componentId: "sc-786a9936-3"
})(_templateObject6(), ui/* device.tablet */.Uh.tablet);
var ImageContainer = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-786a9936-4"
})(_templateObject7(), ui/* color.whisper */.$_.whisper);
var ImageUpload = (0,styled_components_browser_esm["default"])(global_Image/* default */.Z).withConfig({
    componentId: "sc-786a9936-5"
})(_templateObject9(), function(param) {
    var isLongImage = param.isLongImage;
    return isLongImage && (0,styled_components_browser_esm.css)(_templateObject8());
});
var IconCloseWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-6"
})(_templateObject10(), ui/* color.highgray */.$_.highgray, percentToHex(70));
var IconClose = (0,styled_components_browser_esm["default"])(Iconmoon).withConfig({
    componentId: "sc-786a9936-7"
})(_templateObject11(), ui/* color.light */.$_.light, ui/* color.light */.$_.light);
var EmojiContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-8"
})(_templateObject12(), ui/* color.gainsboro */.$_.gainsboro, ui/* device.tablet */.Uh.tablet);
var GifContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-9"
})(_templateObject13(), ui/* color.gainsboro */.$_.gainsboro, ui/* device.tablet */.Uh.tablet);
var MentionSuggestionResult = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-10"
})(_templateObject14());
var AvatarContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-786a9936-11"
})(_templateObject15(), ui/* color.component */.$_.component, ui/* color.lowgray */.$_.lowgray);


;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/Textarea.tsx














var Textarea_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
function Textarea(_param) {
    var value = _param.value, onChange = _param.onChange, onSearch = _param.onSearch, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "onSearch"
    ]);
    var ref = (0,react.useState)(""), searchKeyword = ref[0], setSearchKeyword = ref[1];
    var ref1 = (0,react.useState)("@"), mentionPrefix = ref1[0], setMentionPrefix = ref1[1];
    var ref2 = (0,react.useState)(0), timeInterval = ref2[0], setTimeInterval = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,es/* useSelector */.v9)(user/* selectors */.wl), _search = ref3.search, userSearch = _search.data;
    var ref4 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search1 = ref4.search, companySearch = _search1.data;
    var SEARCH_DATA = {
        "@": {
            data: userSearch,
            dispatch: user/* effects.searchUser */.Sz.searchUser
        },
        $: {
            data: companySearch,
            dispatch: company/* effects.getSearchCompany */.Sz.getSearchCompany
        }
    };
    var handleSearch = function(keyword, prefix) {
        setSearchKeyword(keyword);
        setMentionPrefix(prefix);
        var action = SEARCH_DATA[prefix].dispatch;
        if (keyword.length >= 2) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                dispatch(action(keyword));
            }, 500));
        }
    };
    var searchResult = (0,react.useMemo)(function() {
        if (searchKeyword.length >= 2) {
            var ref;
            return (ref = SEARCH_DATA[mentionPrefix]) === null || ref === void 0 ? void 0 : ref.data;
        }
        return [];
    }, [
        userSearch,
        companySearch,
        searchKeyword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaMentions, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                prefix: [
                    "@",
                    "$"
                ],
                value: value,
                onChange: onChange,
                onSearch: handleSearch,
                notFoundContent: null,
                getPopupContainer: function() {
                    return document.getElementById("compose-mention-container-comment");
                },
                children: searchResult.map(function(_param, index) /*#__PURE__*/ {
                    var id = _param.id, name = _param.name, data = (0,_object_without_properties/* default */.Z)(_param, [
                        "id",
                        "name"
                    ]);
                    return (0,jsx_runtime.jsx)(styled/* MentionOption */.wo, {
                        value: name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Textarea_Flex, {
                            align: "center",
                            children: [
                                mentionPrefix === "@" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                        alt: "avatar-user",
                                        src: "".concat(api/* AVATAR_URL */.q$, "/").concat(data.img),
                                        onError: function(e) {
                                            return (0,general/* handleErrorAvatar */.Tk)(e, name);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                    mr: "8px",
                                    size: "13px",
                                    children: [
                                        mentionPrefix,
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    size: "13px",
                                    children: data.desc
                                })
                            ]
                        })
                    }, "".concat(id, "-").concat(index));
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionSuggestionResult, {
                id: "compose-mention-container-comment"
            })
        ]
    });
}
/* harmony default export */ var ComposeConversation_Textarea = (Textarea);

// EXTERNAL MODULE: ./src/global/StreamCompose/FileContainer/index.tsx
var FileContainer = __webpack_require__(99172);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/StreamConversation/styled.ts

function StreamConversation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  background-color: ",
        ";\n  height: 100vh;\n  @media ",
        " {\n    background: transparent;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n"
    ]);
    StreamConversation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0px !important;\n  margin: 0;\n  max-width: unset;\n  .ant-modal-content {\n    background-color: transparent;\n  }\n  .ant-modal-body {\n    margin-top: 60px;\n  }\n  @media ",
        " {\n    .ant-modal-body {\n      margin-top: 0px;\n      word-wrap: unset;\n    }\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: max-content;\n  @media ",
        " {\n    height: 100%;\n    width: calc(100% - 350px);\n    background: ",
        "",
        ";\n  }\n  @media ",
        " {\n    width: calc(100% - 440px);\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  border-radius: 3px;\n  overflow: hidden;\n  width: ",
        "px;\n  height: max-content;\n  max-height: ",
        "px;\n  transform: translateY(-50%);\n  top: 50%;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  right: 20px;\n  top: 10px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  padding: 10px;\n  z-index: 1000;\n  p {\n    font-size: 8px;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n    position: absolute;\n    right: 25px;\n    top: 25px;\n    z-index: inherit;\n    p {\n      font-size: 14px;\n      :hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 494px;\n  overflow-y: auto;\n  /* margin-top: 20px; */\n  height: ",
        ";\n\n  @media ",
        " {\n    margin-left: 70px;\n    padding-right: 20px;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-left: 10px;\n\n  @media ",
        " {\n    margin-left: 20px;\n  }\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  overflow: hidden;\n  @media ",
        " {\n    overflow: unset;\n  }\n  @media ",
        " {\n    background-color: ",
        ";\n    height: 100%;\n    width: 350px;\n  }\n  @media ",
        " {\n    width: 440px;\n  }\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  margin-bottom: 80px;\n  @media ",
        " {\n    padding: 0px;\n    margin-bottom: 0px;\n  }\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-color: white;\n  }\n  20% {\n    background-color: #fcf8e3;\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease-out forwards;\n    "
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 20px;\n  width: 100%;\n  position: relative;\n  ",
        "\n"
    ]);
    styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  padding: 10px;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-radius: 3px;\n"
    ]);
    styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 0px;\n      -webkit-line-clamp: unset;\n      -moz-line-clamp: unset;\n    "
    ]);
    styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -moz-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  -moz-box-orient: vertical;\n\n  ",
        "\n"
    ]);
    styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  position: absolute;\n  right: 12px;\n  top: 12px;\n"
    ]);
    styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #333;\n  display: flex;\n  justify-content: center;\n  max-height: 336px;\n  overflow: hidden;\n  position: relative;\n  background-color: ",
        ";\n  width: 100%;\n  padding-top: 56.25%;\n\n  && .image-convo-default {\n    width: 100%;\n    object-fit: cover;\n    top: 0px;\n    position: absolute;\n    width: 100%;\n    background: ",
        ";\n  }\n\n  && .image-convo-shadow {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    bottom: 0px;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n    background: ",
        ";\n  }\n\n  img {\n    width: 100%;\n    margin: auto;\n  }\n\n  img[src$='.GIF'],\n  img[src$='.gif'] {\n    width: auto;\n    margin: auto;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  max-height: 422.5px;\n  margin: 12px 0;\n  overflow: hidden;\n  position: relative;\n\n  img {\n    width: 100%;\n  }\n  img[src$='.GIF'],\n  img[src$='.gif'] {\n    width: auto;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 90vh;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px;\n  height: 45px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px;\n  height: auto;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  thead {\n    .ant-table-cell {\n      background: ",
        ";\n    }\n  }\n  .ant-table-tbody > tr > td {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 50px;\n  @media ",
        " {\n    margin-top: 15px;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    margin-left: 70px;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-skeleton-title {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n    height: 20px;\n  }\n\n  .ant-skeleton-paragraph {\n    margin-top: 8px !important;\n    margin-bottom: 0px !important;\n\n    li {\n      height: 20px;\n      margin-top: 8px !important;\n    }\n\n    li:nth-child(1) {\n      width: 114px;\n      margin-top: 0px;\n    }\n\n    li:nth-child(2) {\n      margin-top: 20px !important;\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  .ant-skeleton-title {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n    height: 20px;\n  }\n\n  .ant-skeleton-paragraph {\n    margin-top: 8px !important;\n    margin-bottom: 0px !important;\n\n    li {\n      height: 20px;\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100% !important;\n  .ant-skeleton-button {\n    height: 172px !important;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  padding: 20px;\n  width: 100%;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 0;\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n  width: 100%;\n  height: 90px;\n  @media ",
        " {\n    position: relative;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}




var styled_Flex = ui/* Common.Flex */.Gn.Flex, Modal = ui/* Common.Modal */.Gn.Modal, IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var TableDefault = ui/* Stream.Table */.F6.Table;
var styled_percentToHex = ui/* utils.hexOpacity */.P6.hexOpacity;
var ModalContainer = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-8405cd2-0"
})(StreamConversation_styled_templateObject(), ui/* color.snow */.$_.snow, ui/* device.tablet */.Uh.tablet);
var ModalReply = (0,styled_components_browser_esm["default"])(Modal).withConfig({
    componentId: "sc-8405cd2-1"
})(styled_templateObject1(), ui/* device.tablet */.Uh.tablet);
var StreamContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-2"
})(styled_templateObject2(), ui/* device.tablet */.Uh.tablet, ui/* color.black */.$_.black, styled_percentToHex(45), ui/* device.laptop */.Uh.laptop);
var PostContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-3"
})(styled_templateObject3(), ui/* color.light */.$_.light, function(param) {
    var dimension = param.dimension;
    return dimension.width;
}, function(param) {
    var dimension = param.dimension;
    return dimension.height;
});
var CloseWrapper = (0,styled_components_browser_esm["default"])(IconWrapper).withConfig({
    componentId: "sc-8405cd2-4"
})(styled_templateObject4(), ui/* color.highempahis */.$_.highempahis, ui/* device.tablet */.Uh.tablet, ui/* color.dimgray */.$_.dimgray, ui/* color.light */.$_.light);
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-5"
})(styled_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, ui/* device.tablet */.Uh.tablet);
var HeaderContent = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-8405cd2-6"
})(styled_templateObject6(), ui/* device.tablet */.Uh.tablet);
var ReplyContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-8405cd2-7"
})(styled_templateObject7(), ui/* color.snow */.$_.snow, ui/* device.mobile */.Uh.mobile, ui/* device.tablet */.Uh.tablet, ui/* color.light */.$_.light, ui/* device.laptop */.Uh.laptop);
var ReplyListContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    style: {
        overflowY: "auto",
        height: "100%",
        width: "100%"
    },
    direction: "column"
}).withConfig({
    componentId: "sc-8405cd2-8"
})(styled_templateObject8(), ui/* device.tablet */.Uh.tablet);
var HighlightAnimation = (0,styled_components_browser_esm.keyframes)(styled_templateObject9());
var ReplyContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-9"
})(styled_templateObject11(), ui/* color.light */.$_.light, function(param) {
    var isSelected = param.isSelected;
    return isSelected && (0,styled_components_browser_esm.css)(styled_templateObject10(), HighlightAnimation);
});
var ReplyNestedContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-10"
})(styled_templateObject12(), ui/* color.gainsboro */.$_.gainsboro);
var ReplyTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-11"
})(styled_templateObject14(), function(param) {
    var expanded = param.expanded;
    return expanded && (0,styled_components_browser_esm.css)(styled_templateObject13());
});
var CloseReplyNestedContent = (0,styled_components_browser_esm["default"])(IconWrapper).withConfig({
    componentId: "sc-8405cd2-12"
})(styled_templateObject15());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-13"
})(_templateObject16(), ui/* color.light */.$_.light, ui/* color.light */.$_.light, ui/* color.light */.$_.light);
var ImageItemWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-14"
})(_templateObject17());
var ImgModal = (0,styled_components_browser_esm["default"])(global_Image/* default */.Z).withConfig({
    componentId: "sc-8405cd2-15"
})(_templateObject18());
var Th = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-16"
})(_templateObject19(), ui/* color.gainsboro */.$_.gainsboro);
var Td = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-17"
})(_templateObject20());
var Table = (0,styled_components_browser_esm["default"])(TableDefault).withConfig({
    componentId: "sc-8405cd2-18"
})(_templateObject21(), ui/* color.light */.$_.light, ui/* color.component */.$_.component);
var ItemConversationContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-19"
})(_templateObject22(), ui/* device.tablet */.Uh.tablet);
var FooterContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-20"
})(_templateObject23(), ui/* device.tablet */.Uh.tablet);
var PostWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-21"
})(_templateObject24());
var StreamSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default */.Z).attrs({
    avatar: true,
    paragraph: {
        rows: 4
    },
    active: true
}).withConfig({
    componentId: "sc-8405cd2-22"
})(_templateObject25());
var ComposeConvoSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default */.Z).attrs({
    avatar: true,
    paragraph: {
        rows: 1
    },
    active: true
}).withConfig({
    componentId: "sc-8405cd2-23"
})(_templateObject26());
var ImageSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default.Button */.Z.Button).attrs({
    active: true,
    block: true
}).withConfig({
    componentId: "sc-8405cd2-24"
})(_templateObject27());
var LoadConvoButton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-25"
})(_templateObject28(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro);
var LimitedComposeContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-8405cd2-26"
})(_templateObject29(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet);
var HiddenLayerStreamConvo = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8405cd2-27"
})(_templateObject30());


;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/ImageContainer.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ 







var ImageContainer_Modal = ui/* Common.Modal */.Gn.Modal;
function ImageContainer_ImageContainer(_param) {
    var src = _param.src, imageStyle = _param.imageStyle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "imageStyle"
    ]);
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItemWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                    src: src,
                    alt: "convo pict",
                    onClick: function() {
                        return setVisible(true);
                    },
                    style: imageStyle || {}
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer_Modal, {
                visible: visible,
                centered: true,
                maskClosable: true,
                footer: null,
                width: "auto",
                bodyStyle: {
                    padding: "0px"
                },
                onCancel: function() {
                    return setVisible(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgModal, {
                    alt: "",
                    src: src
                })
            })
        ]
    });
}
/* harmony default export */ var ItemConversation_ImageContainer = (ImageContainer_ImageContainer);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/NestedReplyBox.tsx







var NestedReplyBox_Text = ui/* Common.Text */.Gn.Text, NestedReplyBox_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var MAX_CHARACTER = 100;
function NestedReplyBox(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _username = param.username, username = _username === void 0 ? "" : _username, _closable = param.closable, closable = _closable === void 0 ? false : _closable, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _images = param.images, images = _images === void 0 ? [] : _images;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var showReadMore = content.length >= MAX_CHARACTER;
    var hasImage = images.length > 0 && images[0] !== "";
    var showContent = (0,react.useMemo)(function() {
        if (showReadMore && !expanded) {
            return "".concat(content.substring(0, MAX_CHARACTER), "...");
        }
        return content;
    }, [
        content,
        expanded,
        showReadMore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReplyNestedContent, {
        children: [
            closable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseReplyNestedContent, {
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NestedReplyBox_Iconmoon, {
                    className: "icon-compose_close",
                    size: "14px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NestedReplyBox_Text, {
                color: ui/* color.gainsboro */.$_.gainsboro,
                children: [
                    "Replying to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/".concat(username),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NestedReplyBox_Text, {
                            as: "a",
                            color: ui/* color.primary */.$_.primary,
                            children: [
                                "@",
                                username
                            ]
                        })
                    })
                ]
            }),
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_ImageContainer, {
                src: images[0],
                style: {
                    height: "100px"
                },
                imageStyle: {
                    position: "absolute"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyTextWrapper, {
                expanded: expanded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NestedReplyBox_Text, {
                    m: "10px 0",
                    children: (0,stream/* parseEmoji */.qm)(showContent)
                })
            }),
            showReadMore && !expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(NestedReplyBox_Text, {
                color: ui/* color.primary */.$_.primary,
                style: {
                    cursor: "pointer"
                },
                onClick: function() {
                    return setExpanded(true);
                },
                children: "Read more..."
            })
        ]
    });
}
/* harmony default export */ var ItemConversation_NestedReplyBox = (NestedReplyBox);

// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/global/StreamCompose/Footer/styled.ts
var Footer_styled = __webpack_require__(3);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/global/StreamCompose/Footer/IconFooter.tsx
var IconFooter = __webpack_require__(85895);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/Footer.tsx
/* eslint-disable consistent-return */ 














var EmojiPicker = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79372));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79372)
            ];
        }
    },
    ssr: false
});
var GifPicker = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7674));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7674)
            ];
        }
    },
    ssr: false
});
var Footer_Flex = ui/* Common.Flex */.Gn.Flex, Button = ui/* Common.Button */.Gn.Button, Footer_Text = ui/* Common.Text */.Gn.Text;
function Footer(param) {
    var onCancel = param.onCancel, onSubmit = param.onSubmit, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onSelectEmoji = param.onSelectEmoji, onSelectGif = param.onSelectGif, onSetImages = param.onSetImages, documents = param.documents, onSetDocuments = param.onSetDocuments, onExpandFooter = param.onExpandFooter;
    var pictureRef = (0,react.useRef)(null);
    var documentRef = (0,react.useRef)(null);
    var gifContainerRef = (0,react.useRef)(null);
    var gifButtonRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showEmoji = ref[0], setShowEmoji = ref[1];
    var ref1 = (0,react.useState)(false), showGif = ref1[0], setShowGif = ref1[1];
    var openPictureAttachment = function() {
        pictureRef.current.click();
    };
    var openDocumentAttachment = function() {
        documentRef.current.click();
    };
    var handleChangePicture = function(e) {
        e.preventDefault();
        var reader = new FileReader();
        var imageFile = e.target.files[0];
        reader.onloadend = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var dimensions, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,utils_image/* getImageDimensions */.p)(reader.result);
                    case 2:
                        dimensions = _ctx.sent;
                        data = {
                            file: imageFile,
                            imagePreviewUrl: URL.createObjectURL(imageFile),
                            dimensions: dimensions,
                            isNew: true,
                            type: constants/* IMAGE_TYPE_COMMON */.EZ
                        };
                        onSetImages([
                            data
                        ]);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        reader.readAsDataURL(imageFile);
    };
    var handleChangeDocument = function(e) {
        var documentFiles = (0,_to_consumable_array/* default */.Z)(documents);
        var sameFileCounter = 0;
        // validate documents
        Array.from(e.target.files).forEach(function(fileTarget) {
            // Reference: [web legacy]/app/components/stream/smart/ComposeStream.js
            // line: 489 - 528
            if (fileTarget.type.match("image.*")) {
                (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.DOCUMENT_IMAGE_NOT_ALLOWED */.Z.DOCUMENT_IMAGE_NOT_ALLOWED, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                return false;
            }
            // Max document upload size 20 MB = 20971520 bytes.
            if (fileTarget.size > constants/* MAX_FILE_SIZE */.Tb) {
                (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.MAX_FILE_SIZE */.Z.MAX_FILE_SIZE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                return false;
            }
            // If the file is unique, push into upload file stack
            var fileInStack = documentFiles.filter(function(doc) {
                return doc.name === fileTarget.name;
            });
            if (fileInStack.length === 0 || documentFiles.length === 0) {
                documentFiles.push(fileTarget);
            } else {
                sameFileCounter += 1;
            }
        });
        var filesCount = e.target.files.length;
        var isMaximumFile = filesCount + documents.length - sameFileCounter > 1 || filesCount > 1;
        if (isMaximumFile) {
            return (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.MAX_UPLOAD_FILES */.Z.MAX_UPLOAD_FILES, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        }
        if (documentFiles.length > 0 && documentFiles.length < 2) {
            onSetDocuments(documentFiles);
        } else {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.MAX_UPLOAD_FILES */.Z.MAX_UPLOAD_FILES, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        }
    };
    var handleSelectGif = function(gifData) {
        var newGifData = {
            file: gifData.post,
            imagePreviewUrl: gifData.preview,
            isNew: true,
            type: constants/* IMAGE_TYPE_GIF */.p$
        };
        onSelectGif([
            newGifData
        ]);
        setShowGif(function(prev) {
            return !prev;
        });
        onExpandFooter(false);
    };
    var onClickGifButton = function() {
        setShowGif(function(prev) {
            return !prev;
        });
        setShowEmoji(false);
        onExpandFooter(!showGif);
    };
    var onClickEmojiButton = function() {
        setShowEmoji(function(prev) {
            return !prev;
        });
        setShowGif(false);
        onExpandFooter(!showEmoji);
    };
    var handleClickOutsideGif = function(event) {
        var ref, ref1;
        var isClickButtonGif = gifButtonRef.current && !((ref = gifButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target));
        var isClickResultGif = gifContainerRef.current && !((ref1 = gifContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target));
        if (isClickButtonGif && isClickResultGif) {
            setShowGif(false);
            onExpandFooter(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClickOutsideGif, true);
        return function() {
            document.removeEventListener("click", handleClickOutsideGif, true);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            showEmoji && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiPicker, {
                    onSelectEmoji: onSelectEmoji
                })
            }),
            showGif && /*#__PURE__*/ (0,jsx_runtime.jsx)(GifContainer, {
                ref: gifContainerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GifPicker, {
                    onSelectGif: handleSelectGif
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterComposeWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_Flex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: openPictureAttachment,
                                title: "Image",
                                src: "/icon/compose-image.svg",
                                alt: "compose-image",
                                isVisible: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: openDocumentAttachment,
                                title: "Attachment",
                                src: "/icon/compose-attach.svg",
                                alt: "compose-attachment",
                                isVisible: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                src: showEmoji ? "/icon/chevron-down.svg" : "/icon/compose-emoji.svg",
                                alt: "compose-emoji",
                                title: "Emoji",
                                onClick: onClickEmojiButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                src: "/icon/compose-gif.svg",
                                alt: "compose-gif",
                                title: "Gif",
                                onClick: onClickGifButton,
                                iconRef: gifButtonRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_Flex, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                type: "borderless",
                                htmlType: "button",
                                height: "28px",
                                onClick: onCancel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Text, {
                                    color: ui/* color.highgray */.$_.highgray,
                                    size: "12px",
                                    children: "Cancel"
                                })
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                style: {
                                    color: ui/* color.primary */.$_.primary,
                                    fontSize: "20px"
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styled/* ButtonSubmit */.GX, {
                                type: "primary",
                                htmlType: "submit",
                                height: "28px",
                                p: "0 12px",
                                onClick: onSubmit,
                                loading: isLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Text, {
                                    color: "inherit",
                                    size: "12px",
                                    children: "Post"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        ref: pictureRef,
                        style: {
                            display: "none"
                        },
                        accept: "image/*",
                        onChange: handleChangePicture
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        ref: documentRef,
                        style: {
                            display: "none"
                        },
                        accept: constants/* ALLOWED_DOC_EXT.join */.ox.join(","),
                        onChange: handleChangeDocument,
                        multiple: true
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ComposeConversation_Footer = (Footer);

// EXTERNAL MODULE: ./src/global/StreamCompose/ImageContainer/styled.ts
var ImageContainer_styled = __webpack_require__(23529);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/ImageItem.tsx




function ImageItem(param) {
    var imageSrc = param.image, imageDimensions = param.imageDimensions, onDelete = param.onDelete;
    if (!imageSrc) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var longImage = false;
    if (imageDimensions) {
        var width = imageDimensions.width, height = imageDimensions.height;
        if (width && height) {
            // if image ratio from input more than 16/9 set longImage to true
            // it will adjust default style
            longImage = width / height > 1.77;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer_styled/* Relative */.Ig, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCloseWrapper, {
                onClick: onDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {
                    className: "icon-compose_close"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUpload, {
                    alt: "uploader",
                    src: imageSrc,
                    isLongImage: longImage
                })
            })
        ]
    });
}
/* harmony default export */ var ComposeConversation_ImageItem = (/*#__PURE__*/react.memo(ImageItem));

;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/index.tsx

















var ComposeConversation_Flex = ui/* Common.Flex */.Gn.Flex, Avatar = ui/* Common.Avatar */.Gn.Avatar, ComposeConversation_Text = ui/* Common.Text */.Gn.Text;
function ComposeConversation(param) {
    var onSubmit = param.onSubmit, onCancel = param.onCancel, _repliedComment = param.repliedComment, repliedComment = _repliedComment === void 0 ? null : _repliedComment, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _avatar = param.avatar, avatar = _avatar === void 0 ? "" : _avatar, _username = param.username, username = _username === void 0 ? "stockbit" : _username;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isExpand = ref2[0], setIsExpand = ref2[1];
    var ref3 = (0,react.useState)(false), isReplyComment = ref3[0], setIsReplyComment = ref3[1];
    var ref4 = (0,react.useState)(""), content = ref4[0], setContent = ref4[1];
    var ref5 = (0,react.useState)([]), documents = ref5[0], setDocuments = ref5[1];
    var ref6 = (0,react.useState)([]), images = ref6[0], setImages = ref6[1];
    var ref7 = (0,react.useState)(false), isFooterExpanded = ref7[0], setIsFooterExpanded = ref7[1];
    var ref8 = ComposeConversation_useDropFile({
        isAllowedToUpload: isExpand,
        onErrorMaxSize: function() {},
        setDocuments: setDocuments,
        setImages: setImages,
        images: images,
        documents: documents
    }), dropzoneRef = ref8.dropzoneRef, handleOnDragOver = ref8.handleOnDragOver, handleOnDragStart = ref8.handleOnDragStart, handleOnDrop = ref8.handleOnDrop;
    (0,react.useEffect)(function() {
        setIsReplyComment(!!repliedComment);
        if (repliedComment) {
            // set initial content
            setContent("@".concat(repliedComment.username, " "));
            setIsExpand(true);
        }
    }, [
        repliedComment
    ]);
    var handleReset = function() {
        setContent("");
        setDocuments([]);
        setImages([]);
        setIsReplyComment(false);
        setIsExpand(false);
        setIsFooterExpanded(false);
    };
    var handleChangeContent = function(value) {
        setContent(value);
    };
    var handleSelectEmoji = function(emoji) {
        setContent("".concat(content, " ").concat(emoji, " "));
    };
    var handleToggleExpand = function() {
        setIsExpand(!isExpand);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var data, submit;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (content) {
                            _ctx.next = 4;
                            break;
                        }
                        (0,AlertMessage/* default */.Z)({
                            content: errorMessage/* default.STREAM_TEXT_REQUIRED */.Z.STREAM_TEXT_REQUIRED,
                            alertType: "snackbar",
                            messageType: "error",
                            hasCloseIcon: true
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        data = {
                            content: content,
                            image: images,
                            file: documents
                        };
                        if (isReplyComment) {
                            data.replyto = repliedComment.postid;
                        }
                        _ctx.next = 8;
                        return onSubmit(data);
                    case 8:
                        submit = _ctx.sent;
                        if (submit) {
                            handleReset();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        handleReset();
        setIsExpand(false);
        onCancel();
    };
    var handleResetImage = function() {
        setImages([]);
    };
    var handleCloseNestedReply = function() {
        setIsReplyComment(false);
        onCancel();
    };
    var avatarUrl = "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyCompose, {
        isExpand: isExpand,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onDragEnter: handleOnDragStart,
            onDragOver: handleOnDragOver,
            onDrop: handleOnDrop,
            ref: dropzoneRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComposeConversation_Flex, {
                        align: "flex-start",
                        padding: isExpand ? "20px 20px 0 20px" : "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                size: "small",
                                padding: "0px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                    alt: "imageprofile",
                                    src: avatarUrl,
                                    onError: function(e) {
                                        return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                    }
                                })
                            }),
                            isExpand ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComposeContent, {
                                isExpand: isExpand,
                                isFooterExpanded: isFooterExpanded,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_Textarea, {
                                        placeholder: "Tulis komen kamu disini...",
                                        value: content,
                                        onChange: handleChangeContent
                                    }),
                                    images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_ImageItem, {
                                        image: (ref = images[0]) === null || ref === void 0 ? void 0 : ref.imagePreviewUrl,
                                        imageDimensions: (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.dimensions,
                                        onDelete: handleResetImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_Flex, {
                                        mb: "10px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileContainer/* default */.Z, {
                                            documents: documents,
                                            onSetDocuments: setDocuments
                                        })
                                    }),
                                    isReplyComment && repliedComment && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_NestedReplyBox, {
                                        content: repliedComment.content_original || repliedComment.title,
                                        username: repliedComment.username,
                                        images: repliedComment.images,
                                        closable: true,
                                        onClose: handleCloseNestedReply
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_Text, {
                                mt: "12px",
                                ml: "10px",
                                color: ui/* color.primary */.$_.primary,
                                onClick: handleToggleExpand,
                                children: "Tulis komen kamu disini..."
                            })
                        ]
                    }),
                    isExpand && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_Footer, {
                        onCancel: handleCancel,
                        onSubmit: handleSubmit,
                        onSelectEmoji: handleSelectEmoji,
                        onSelectGif: setImages,
                        isLoading: isLoading,
                        onSetDocuments: setDocuments,
                        onSetImages: setImages,
                        documents: documents,
                        onExpandFooter: function(val) {
                            return setIsFooterExpanded(val);
                        }
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var StreamConversation_ComposeConversation = (ComposeConversation);

// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/global/ModalShare/index.tsx + 9 modules
var ModalShare = __webpack_require__(41232);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/index.tsx + 9 modules
var Modals = __webpack_require__(50700);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var StreamWidget_slice = __webpack_require__(47225);
;// CONCATENATED MODULE: ./src/global/StreamConversation/DetailStream/Footer.tsx
/* eslint-disable no-unused-vars */ 















var DetailStream_Footer_Flex = ui/* Common.Flex */.Gn.Flex, DetailStream_Footer_Text = ui/* Common.Text */.Gn.Text, Footer_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Footer_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
function Footer_Footer(param) {
    var post = param.post, onComment = param.onComment;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,react.useState)(false), modalShare = ref1[0], showModalShare = ref1[1];
    var ref2 = (0,react.useState)(false), modalTipping = ref2[0], showModalTipping = ref2[1];
    var ref3 = (0,react.useState)(false), modalLike = ref3[0], showModalLike = ref3[1];
    var ref4 = (0,react.useState)(false), modalInsight = ref4[0], showModalInsight = ref4[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    var handleLikePost = function() {
        var action = liked ? StreamWidget_slice/* effects.unlikePost */.Sz.unlikePost : StreamWidget_slice/* effects.likePost */.Sz.likePost;
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatData) {
            var send, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.sendBulkChat */.Sz.sendBulkChat((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var urlToShare = (0,react.useMemo)(function() {
        var path = !app/* PROJECT_FOLDER */.sP || app/* PROJECT_FOLDER */.sP === "/" ? "/" : "/".concat(app/* PROJECT_FOLDER */.sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* FooterContainer */.bk, {
        style: {
            marginBottom: "0px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailStream_Footer_Flex, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailStream_Footer_Flex, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    likes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailStream_Footer_Text, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: [
                                            likes,
                                            " likes"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Footer_Flex, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_IconWrapper, {
                                            onClick: handleLikePost,
                                            children: liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Footer_Flex, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_IconWrapper, {
                                    onClick: function() {
                                        return showModalShare(true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                        src: "/icon/post-stream/share.svg",
                                        alt: "Share post",
                                        style: {
                                            width: "20px"
                                        }
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Iconmoon, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: ui/* color.dimgray */.$_.dimgray,
                                    hoverColor: ui/* color.dimgray */.$_.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalTipping(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailStream_Footer_Flex, {
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Footer_Text, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_IconWrapper, {
                                onClick: onComment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalTipping */.MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalLike */.gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalInsight */.eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            })
        ]
    });
}
/* harmony default export */ var DetailStream_Footer = (Footer_Footer);

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/global/StreamConversation/DetailStream/TableSymbol.tsx
/* eslint-disable no-nested-ternary */ 




var TableSymbol_Text = ui/* Common.Text */.Gn.Text, TableSymbol_Flex = ui/* Common.Flex */.Gn.Flex;
var textColor = {
    profit: ui/* color.primary */.$_.primary,
    loss: ui/* color.sunsetOrange */.$_.sunsetOrange,
    neutral: ui/* color.suvaGrey */.$_.suvaGrey
};
var priceSymbol = {
    profit: "+",
    loss: "-",
    neutral: ""
};
function TableSymbol(param) {
    var topics = param.topics, postedDate = param.postedDate;
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                    family: "bold",
                    children: "Symbol"
                })
            }),
            dataIndex: "symbol",
            key: "symbol"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Th, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                        family: "bold",
                        align: "right",
                        children: "Posted on"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                        color: ui/* color.dimgray */.$_.dimgray,
                        size: "12px",
                        align: "right",
                        children: postedDate
                    })
                ]
            }),
            dataIndex: "price",
            key: "price"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                    family: "bold",
                    align: "right",
                    children: "Current Price"
                })
            }),
            dataIndex: "change",
            key: "change"
        }, 
    ];
    var dataSource = topics.map(function(topic) {
        var priceStatus = "neutral";
        if ((topic === null || topic === void 0 ? void 0 : topic.pchange) > 0) {
            priceStatus = "profit";
        } else if ((topic === null || topic === void 0 ? void 0 : topic.pchange) < 0) {
            priceStatus = "loss";
        }
        var price = topic.price || parseInt(topic.price, 10) === 0 ? numeral_default()(topic.price).format("0,0[.]00") : "NA";
        var lastPrice = topic.latest ? numeral_default()(topic.latest.lastprice).format("0,0[.]00") : null;
        var change = topic.change || parseInt(topic.change, 10) === 0 ? numeral_default()(topic.change).format("0[.]00") : "NA";
        var pChange = topic.pchange || parseInt(topic.pchange, 10) === 0 ? numeral_default()(Math.abs(topic.pchange)).format("0.00") : null;
        return {
            key: "1",
            symbol: /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/symbol/".concat(topic.symbol),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                            color: ui/* color.primary */.$_.primary,
                            height: "1.55",
                            children: topic.symbol
                        })
                    })
                })
            }),
            price: /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSymbol_Text, {
                    align: "right",
                    height: "1.55",
                    color: ui/* color.nero */.$_.nero,
                    children: price
                })
            }),
            change: /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableSymbol_Flex, {
                    justify: "end",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableSymbol_Text, {
                            align: "right",
                            color: ui/* color.nero */.$_.nero,
                            height: "1.55",
                            children: [
                                lastPrice,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableSymbol_Text, {
                            as: "span",
                            color: textColor[priceStatus],
                            align: "right",
                            ml: "5px",
                            style: {
                                minWidth: "100px"
                            },
                            children: [
                                change,
                                " ",
                                " ",
                                "(",
                                priceSymbol[priceStatus],
                                pChange,
                                "%)"
                            ]
                        })
                    ]
                })
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
        columns: columns,
        dataSource: dataSource,
        pagination: false
    });
}
/* harmony default export */ var DetailStream_TableSymbol = (TableSymbol);

;// CONCATENATED MODULE: ./src/global/StreamConversation/DetailStream/ImageDetail.tsx





var ImageDetail_Modal = ui/* Common.Modal */.Gn.Modal;
function ImageDetail(param) {
    var src = param.src;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                        src: src,
                        alt: "stream pict",
                        className: "image-convo-default",
                        onClick: function() {
                            return setVisible(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                        src: src,
                        alt: "stream pict",
                        className: "image-convo-shadow",
                        onClick: function() {
                            return setVisible(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageDetail_Modal, {
                visible: visible,
                centered: true,
                maskClosable: true,
                footer: null,
                width: "auto",
                style: {
                    padding: 0
                },
                onCancel: function() {
                    return setVisible(false);
                },
                transitionName: "",
                maskTransitionName: "",
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgModal, {
                    alt: "",
                    src: src
                })
            })
        ]
    });
}
/* harmony default export */ var DetailStream_ImageDetail = (ImageDetail);

// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/StreamItemOption.tsx + 5 modules
var StreamItemOption = __webpack_require__(98453);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/styled.ts

function ItemConversation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    ItemConversation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  display: block;\n  color: ",
        ";\n  font-size: 12px;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    ItemConversation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    ItemConversation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  margin-top: 15px;\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    ItemConversation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  padding: 0 4px;\n  color: #b5b5b5;\n"
    ]);
    ItemConversation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-left: 10px;\n"
    ]);
    ItemConversation_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    ItemConversation_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    color: inherit;\n  }\n\n  ",
        "\n"
    ]);
    ItemConversation_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    ItemConversation_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ItemConversation_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #F7F7F7; // TODO: Add color to stockbit/ui\n  padding: 12px 20px;\n  margin-top: 20px;\n\n  img {\n    margin-right: 10px;\n  }\n"
    ]);
    ItemConversation_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var styled_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, ItemConversation_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var ButtonIcon = (0,styled_components_browser_esm["default"])(styled_IconWrapper).withConfig({
    componentId: "sc-a46065fd-0"
})(ItemConversation_styled_templateObject(), ui/* device.tablet */.Uh.tablet);
var ButtonText = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-a46065fd-1"
})(ItemConversation_styled_templateObject1(), ui/* color.midgray */.$_.midgray, ui/* device.tablet */.Uh.tablet);
var FooterMobile = (0,styled_components_browser_esm["default"])(ItemConversation_styled_Flex).withConfig({
    componentId: "sc-a46065fd-2"
})(ItemConversation_styled_templateObject2(), ui/* device.tablet */.Uh.tablet);
var FooterWeb = (0,styled_components_browser_esm["default"])(ItemConversation_styled_Flex).withConfig({
    componentId: "sc-a46065fd-3"
})(ItemConversation_styled_templateObject3(), ui/* device.tablet */.Uh.tablet);
var Separator = styled_components_browser_esm["default"].em.withConfig({
    componentId: "sc-a46065fd-4"
})(ItemConversation_styled_templateObject4());
var styled_HeaderContent = (0,styled_components_browser_esm["default"])(ItemConversation_styled_Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-a46065fd-5"
})(ItemConversation_styled_templateObject5());
var TextHeader = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-a46065fd-6"
})(ItemConversation_styled_templateObject7(), function(param) {
    var textColor = param.color;
    return textColor && (0,styled_components_browser_esm.css)(ItemConversation_styled_templateObject6(), textColor);
});
var TextDate = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-a46065fd-7"
})(ItemConversation_styled_templateObject8(), ui/* device.tablet */.Uh.tablet);
var CommentLimitInfoContainer = (0,styled_components_browser_esm["default"])(ItemConversation_styled_Flex).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a46065fd-8"
})(ItemConversation_styled_templateObject9());


// EXTERNAL MODULE: ./src/global/StreamWidget/Popover/index.tsx + 12 modules
var Popover = __webpack_require__(77977);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/Avatar.tsx







var Avatar_Avatar = ui/* Common.Avatar */.Gn.Avatar;
function UserAvatar(param) {
    var username = param.username, avatar = param.avatar, avatarSize = param.avatarSize, showPopover = param.showPopover;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    if (showPopover) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* PopoverUser */.q, {
            username: username,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(username),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            color: "unset"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar_Avatar, {
                            size: avatarSize,
                            padding: "0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                },
                                style: {
                                    cursor: "pointer"
                                }
                            })
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar_Avatar, {
        size: avatarSize,
        padding: "0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
            alt: "imageProfile",
            src: avatarUrl,
            onError: function(e) {
                return (0,general/* handleErrorAvatar */.Tk)(e, username);
            }
        })
    });
}
/* harmony default export */ var ItemConversation_Avatar = (UserAvatar);

;// CONCATENATED MODULE: ./src/global/StreamConversation/DetailStream/Header.tsx









var Header_Flex = ui/* Common.Flex */.Gn.Flex, Header_Text = ui/* Common.Text */.Gn.Text;
function Header(param) {
    var post = param.post, handleClose = param.handleClose;
    var avatar = post.avatar, username = post.username, official = post.official, saved = post.saved, follow = post.follow, postid = post.postid, userid = post.userid, privilege = post.user_priv, created = post.created_display, updated = post.updated, polling = post.polling;
    var isFollowed = follow === 1;
    var hasEdited = updated !== "0000-00-00 00:00:00";
    var isPolling = polling.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_Avatar, {
                avatar: avatar,
                avatarSize: "medium",
                username: username,
                showPopover: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/".concat(username),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            style: {
                                                color: "unset"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextHeader, {
                                                size: "16px",
                                                family: "bold",
                                                children: username
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                        align: "center",
                                        height: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                                deprecatedVerifiedStatus: official > 0,
                                                verifiedStatus: post === null || post === void 0 ? void 0 : post.verified_status
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                                privilege: privilege
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Text, {
                                size: "12px",
                                color: ui/* color.midgray */.$_.midgray,
                                children: [
                                    created,
                                    hasEdited ? " Edited on ".concat((0,format/* default */.Z)((0,parseISO/* default */.Z)(updated), "d MMM yy, HH:mm")) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamItemOption/* default */.Z, {
                        userId: userid,
                        postId: postid,
                        post: post,
                        saved: saved,
                        followed: isFollowed,
                        isPolling: isPolling,
                        type: "post",
                        handleCloseConvo: handleClose,
                        showFollowNotification: true,
                        entryPoint: "conversation"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DetailStream_Header = (Header);

;// CONCATENATED MODULE: ./src/global/StreamConversation/DetailStream/index.tsx
/* eslint-disable camelcase */ 















var DetailStream_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, DetailStream_Flex = ui/* Common.Flex */.Gn.Flex, DetailStream_Text = ui/* Common.Text */.Gn.Text;
function DetailStream(param) {
    var post = param.post, onCancel = param.onCancel, _topics = param.topics, topics = _topics === void 0 ? [] : _topics, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, handleClose = param.handleClose, dimension = param.dimension;
    var content = post.content, contentOriginal = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, isAuthor = post.is_author;
    if (isLoading || Object.keys(post).length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseWrapper, {
                    onClick: onCancel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Iconmoon, {
                        className: "icon-compose_close",
                        color: ui/* color.light */.$_.light
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostContainer, {
                    dimension: dimension,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamSkeleton, {})
                        })
                    ]
                })
            ]
        });
    }
    var youtubeUrl = (0,stream/* getYoutubeURL */.Zu)(content);
    var hasImage = images.length > 0 && images[0] !== "";
    var hasYoutube = youtubeUrl !== null;
    var hasMediaContent = hasImage || hasYoutube;
    var contentWrapperHeight = "calc(100% - 400px)";
    if (post.likes > 0 && hasMediaContent) {
        contentWrapperHeight = "130px";
    }
    if (post.likes === 0 && hasMediaContent) {
        contentWrapperHeight = "150px";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenLayerStreamConvo, {
                onClick: onCancel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseWrapper, {
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Iconmoon, {
                    className: "icon-compose_close",
                    color: ui/* color.light */.$_.light
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostContainer, {
                dimension: dimension,
                children: [
                    hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_ImageDetail, {
                        src: images[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Header, {
                                post: post,
                                handleClose: handleClose
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                                height: contentWrapperHeight,
                                children: [
                                    polling.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                                        post: post,
                                        isSinglePost: true
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                                title: title,
                                                titleUrl: titleurl
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                                content: content,
                                                maskedHtml: mask_html
                                            }),
                                            !hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                                content: contentOriginal
                                            }),
                                            post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailStream_Flex, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                                        alt: post.newsfeed_label,
                                                        src: post.newsfeed_img,
                                                        style: {
                                                            width: "16px",
                                                            marginRight: "8px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Text, {
                                                        size: "12px",
                                                        children: post.newsfeed_label
                                                    })
                                                ]
                                            }),
                                            attachment.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                                documents: attachment
                                            }),
                                            target_price.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                                targetPrice: target_price[0],
                                                postid: post.postid,
                                                isAuthor: isAuthor
                                            }),
                                            reposted > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                                                post: repostedfrom
                                            })
                                        ]
                                    }),
                                    (topics === null || topics === void 0 ? void 0 : topics.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_TableSymbol, {
                                        topics: topics,
                                        postedDate: post.created_display
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStream_Footer, {
                                    post: post,
                                    onComment: onCancel
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamConversation_DetailStream = (DetailStream);

// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/Header.tsx









var ItemConversation_Header_Flex = ui/* Common.Flex */.Gn.Flex;
function Header_Header(param) {
    var post = param.post, type = param.type, isAuthorDetailPost = param.isAuthorDetailPost, handleClose = param.handleClose;
    var avatar = post.avatar, username = post.username, official = post.official, saved = post.saved, follow = post.follow, postid = post.postid, userid = post.userid, privilege = post.user_priv, created = post.created_display, updated = post.updated, polling = post.polling;
    var isFollowed = follow === 1;
    var hasEdited = updated !== "0000-00-00 00:00:00";
    var isPolling = polling.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemConversation_Header_Flex, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_Avatar, {
                avatar: avatar,
                avatarSize: "small",
                username: username,
                showPopover: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_HeaderContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemConversation_Header_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* PopoverUser */.q, {
                                        username: username,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(username),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    style: {
                                                        color: "unset"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextHeader, {
                                                        size: "16px",
                                                        family: "bold",
                                                        children: username
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemConversation_Header_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                                deprecatedVerifiedStatus: official > 0,
                                                verifiedStatus: post === null || post === void 0 ? void 0 : post.verified_status
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                                privilege: privilege
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/post/".concat(postid),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    style: {
                                        color: "unset"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextDate, {
                                        size: "12px",
                                        color: ui/* color.midgray */.$_.midgray,
                                        children: [
                                            created,
                                            hasEdited ? " Edited on ".concat((0,format/* default */.Z)((0,parseISO/* default */.Z)(updated), "d MMM yy, HH:mm")) : null
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamItemOption/* default */.Z, {
                        userId: userid,
                        postId: postid,
                        post: post,
                        saved: saved,
                        followed: isFollowed,
                        isPolling: isPolling,
                        type: type,
                        handleCloseConvo: handleClose,
                        showFollowNotification: false,
                        showDeleteAsAuthor: isAuthorDetailPost,
                        entryPoint: "comment"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ItemConversation_Header = (Header_Header);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/Footer/Web.tsx






var Web_Flex = ui/* Common.Flex */.Gn.Flex, Web_Text = ui/* Common.Text */.Gn.Text, Web_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Web_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
function Web(param) {
    var likes = param.likes, liked = param.liked, isAuthor = param.isAuthor, showInsight = param.showInsight, onClickInsight = param.onClickInsight, onClickLike = param.onClickLike, onClickLikers = param.onClickLikers, onClickShare = param.onClickShare, onClickTipping = param.onClickTipping, onClickComment = param.onClickComment;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            likes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Web_Text, {
                as: "a",
                className: "likes-info",
                onClick: onClickLikers,
                children: [
                    likes,
                    " like",
                    likes > 1 && "s"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWeb, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Web_Flex, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Flex, {
                                    padding: "0 20px 0 0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_IconWrapper, {
                                        onClick: onClickLike,
                                        children: liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                            src: "/icon/post-stream/like-fill.svg",
                                            alt: "Like post filled",
                                            style: {
                                                width: "20px"
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                            src: "/icon/post-stream/like.svg",
                                            alt: "Like post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Flex, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_IconWrapper, {
                                    onClick: onClickShare,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                        src: "/icon/post-stream/share.svg",
                                        alt: "Share post",
                                        style: {
                                            width: "20px",
                                            height: "20px"
                                        }
                                    })
                                })
                            }),
                            showInsight && /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: onClickInsight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Iconmoon, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: ui/* color.dimgray */.$_.dimgray,
                                    hoverColor: ui/* color.dimgray */.$_.dimgray
                                })
                            }),
                            !isAuthor && country === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon, {
                                padding: "0 20px 0 0",
                                onClick: onClickTipping,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_IconWrapper, {
                        onClick: onClickComment,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                            src: "/icon/post-stream/comment.svg",
                            alt: "Icon Comment New",
                            style: {
                                width: "20px"
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Footer_Web = (Web);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/Footer/Mobile.tsx



var Mobile_Flex = ui/* Common.Flex */.Gn.Flex, Mobile_Text = ui/* Common.Text */.Gn.Text, Mobile_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Mobile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
function Mobile(param) {
    var likes = param.likes, liked = param.liked, created = param.created, showInsight = param.showInsight, onClickInsight = param.onClickInsight, onClickLike = param.onClickLike, onClickLikers = param.onClickLikers, onClickShare = param.onClickShare, onClickComment = param.onClickComment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobile, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile_Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Text, {
                                    size: "12px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    children: created
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                                    onClick: onClickLike,
                                    children: liked ? "Unlike" : "Like"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {
                        children: "\xb7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Flex, {
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                            onClick: onClickShare,
                            children: "Share"
                        })
                    }),
                    likes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile_Flex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_IconWrapper, {
                                padding: "0 0 0 5px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Iconmoon, {
                                    className: "icon-stream-likecircle",
                                    size: "12px",
                                    color: ui/* color.primary */.$_.primary
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Text, {
                                size: "12px",
                                color: ui/* color.midgray */.$_.midgray,
                                ml: "2px",
                                onClick: onClickLikers,
                                children: likes
                            })
                        ]
                    }),
                    showInsight && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_IconWrapper, {
                        padding: "0 20px 0 0",
                        onClick: onClickInsight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Iconmoon, {
                            className: "icon-new_analytics",
                            size: "16px",
                            color: ui/* color.dimgray */.$_.dimgray
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                onClick: onClickComment,
                children: "Reply"
            })
        ]
    });
}
/* harmony default export */ var Footer_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/Footer/index.tsx















function ItemConversation_Footer_Footer(param) {
    var post = param.post, onComment = param.onComment;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), modalShare = ref[0], showModalShare = ref[1];
    var ref1 = (0,react.useState)(false), modalTipping = ref1[0], showModalTipping = ref1[1];
    var ref2 = (0,react.useState)(false), modalLike = ref2[0], showModalLike = ref2[1];
    var ref3 = (0,react.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var likes = post.likes, liked = post.liked, postid = post.postid, created = post.created_display;
    var handleLikePost = function() {
        var action = liked ? StreamWidget_slice/* effects.unlikePost */.Sz.unlikePost : StreamWidget_slice/* effects.likePost */.Sz.likePost;
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatData) {
            var send, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.sendBulkChat */.Sz.sendBulkChat((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var showInsight = post.analytics;
    var urlToShare = (0,react.useMemo)(function() {
        var path = !app/* PROJECT_FOLDER */.sP || app/* PROJECT_FOLDER */.sP === "/" ? "/" : "/".concat(app/* PROJECT_FOLDER */.sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* FooterContainer */.bk, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Web, {
                likes: likes,
                liked: liked,
                isAuthor: post.is_author,
                showInsight: showInsight,
                onClickInsight: function() {
                    return showModalInsight(true);
                },
                onClickLike: handleLikePost,
                onClickLikers: function() {
                    return showModalLike(true);
                },
                onClickShare: function() {
                    return showModalShare(true);
                },
                onClickTipping: function() {
                    return showModalTipping(true);
                },
                onClickComment: onComment
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Mobile, {
                likes: likes,
                liked: liked,
                created: created,
                showInsight: showInsight,
                onClickInsight: function() {
                    return showModalInsight(true);
                },
                onClickLike: handleLikePost,
                onClickLikers: function() {
                    return showModalLike(true);
                },
                onClickShare: function() {
                    return showModalShare(true);
                },
                onClickComment: onComment
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalTipping */.MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalLike */.gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalInsight */.eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            })
        ]
    });
}
/* harmony default export */ var ItemConversation_Footer = (ItemConversation_Footer_Footer);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/CommentLimitInfo.tsx





var CommentLimitInfo_Text = ui/* Common.Text */.Gn.Text;
function CommentLimitInfo(param) {
    var type = param.type;
    if (type === "COMMENTER_TYPE_EVERYONE") {
        return null;
    }
    var commentText = constants/* COMMENT_SETTING_LIST.find */.l2.find(function(comment) {
        return comment.type === type;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentLimitInfoContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                src: "/icon/comment-limit.svg",
                alt: "Comment Limit",
                width: "24px",
                height: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentLimitInfo_Text, {
                        size: "12px",
                        color: ui/* color.highgray */.$_.highgray,
                        family: "bold",
                        height: "16px",
                        children: "Comments Limited"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentLimitInfo_Text, {
                        size: "12px",
                        color: ui/* color.highgray */.$_.highgray,
                        height: "16px",
                        children: commentText.label
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ItemConversation_CommentLimitInfo = (CommentLimitInfo);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ItemConversation/index.tsx














function ItemConversation(param) {
    var post = param.post, _showCommentLimitInfo = param.showCommentLimitInfo, showCommentLimitInfo = _showCommentLimitInfo === void 0 ? false : _showCommentLimitInfo, isAuthorDetailPost = param.isAuthorDetailPost, type = param.type, onComment = param.onComment, handleClose = param.handleClose;
    var content = post.content, polling = post.polling, contentOriginal = post.content_original, maskHtml = post.mask_html, replyto = post.replyto, replyContent = post.reply_content, images = post.images, imageData = post.images_data, attachment = post.attachment, targetPrice = post.target_price, reposted = post.reposted, repostedfrom = post.repostedfrom, frameType = post.image_frame_type, title = post.title, titleurl = post.titleurl, isAuthor = post.is_author;
    var handleComment = function() {
        onComment(post);
    };
    var isHaveImage = images.length > 0 && images[0] !== "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_Header, {
                post: post,
                type: type,
                isAuthorDetailPost: isAuthorDetailPost,
                handleClose: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemConversationContainer, {
                children: [
                    polling.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                title: title,
                                titleUrl: titleurl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                content: content,
                                maskedHtml: maskHtml
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imageData,
                                frameType: frameType,
                                mode: "comment"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: contentOriginal
                            }),
                            attachment.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                documents: attachment
                            }),
                            targetPrice.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                targetPrice: targetPrice[0],
                                postid: post.postid,
                                isAuthor: isAuthor
                            }),
                            parseInt(replyto, 10) > 0 && replyContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_NestedReplyBox, {
                                content: replyContent.content,
                                username: replyContent.username
                            })
                        ]
                    }),
                    reposted > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_Footer, {
                        post: post,
                        onComment: handleComment
                    }),
                    showCommentLimitInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemConversation_CommentLimitInfo, {
                        type: post.commenter_type
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamConversation_ItemConversation = (ItemConversation);

;// CONCATENATED MODULE: ./src/global/StreamConversation/ComposeConversation/ComposeLimited.tsx



var ComposeLimited_Text = ui/* Common.Text */.Gn.Text;
function ComposeLimited() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitedComposeContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeLimited_Text, {
            color: ui/* color.highgray */.$_.highgray,
            height: "21px",
            children: "Comments on this post have been limited."
        })
    });
}
/* harmony default export */ var ComposeConversation_ComposeLimited = (ComposeLimited);

// EXTERNAL MODULE: ./src/global/StreamConversation/slice.ts
var StreamConversation_slice = __webpack_require__(61048);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
;// CONCATENATED MODULE: ./src/global/StreamConversation/index.tsx





















var StreamConversation_Text = ui/* Common.Text */.Gn.Text, StreamConversation_Flex = ui/* Common.Flex */.Gn.Flex;
function StreamConversation(_param) {
    var onCancel = _param.onCancel, postId = _param.postId, _parentId = _param.parentId, parentId = _parentId === void 0 ? 0 : _parentId, visible = _param.visible, activeCommentId = _param.activeCommentId, openConversation = _param.openConversation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "postId",
        "parentId",
        "visible",
        "activeCommentId",
        "openConversation"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(null), repliedComment = ref5[0], setRepliedComment = ref5[1];
    var ref6 = (0,react.useState)(false), hasLoadMore = ref6[0], setLoadMore = ref6[1];
    var ref7 = (0,react.useState)(false), hasAutoLoad = ref7[0], setHasAutoLoad = ref7[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref8 = (0,es/* useSelector */.v9)(StreamConversation_slice/* selectors */.wl), isLoadingInitial = ref8.isLoading, isLoadingMore = ref8.isLoadingMore, selected = ref8.selected;
    var ref9 = (0,es/* useSelector */.v9)(entities_stream/* selectors */.wl), _composeConversation = ref9.composeConversation, isLoadingCompose = _composeConversation.isLoading;
    var ref10 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref10.data, avatar = _data.avatar, username = _data.username;
    var scrollToComment = function(commentId) {
        var contentElement = document.getElementById("reply-content-container");
        var commentElement = document.getElementById("convo-".concat(commentId));
        if (commentElement) {
            contentElement.scrollTo({
                top: commentElement.offsetTop - contentElement.offsetTop - commentElement.offsetHeight * 0.1
            });
        }
    };
    var handleInitialLoad = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var getConvo, _payload, data, error, ref, moreData, showActiveComment, ref1, commentElement, ref2, lastReplyPostId, contentElement;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(StreamConversation_slice/* effects.getStreamConversation */.Sz.getStreamConversation({
                            postId: postId,
                            parentId: parentId
                        }));
                    case 2:
                        getConvo = _ctx.sent;
                        _payload = getConvo.payload, data = _payload.data, error = _payload.error;
                        if (error) {
                            _ctx.next = 19;
                            break;
                        }
                        ;
                        moreData = data.prev;
                        setLoadMore(moreData);
                        showActiveComment = activeCommentId !== (data === null || data === void 0 ? void 0 : (ref = data.parent) === null || ref === void 0 ? void 0 : ref.postid);
                        // open conversation modal
                        openConversation();
                        if (!showActiveComment) {
                            _ctx.next = 15;
                            break;
                        }
                        ;
                        commentElement = document.getElementById("convo-".concat(activeCommentId));
                        if (commentElement) {
                            scrollToComment(activeCommentId);
                        } else if ((data === null || data === void 0 ? void 0 : (ref1 = data.replies) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                            ;
                            lastReplyPostId = (ref2 = data === null || data === void 0 ? void 0 : data.replies[0]) === null || ref2 === void 0 ? void 0 : ref2.postid;
                            setHasAutoLoad(true);
                            handleLoadMore(lastReplyPostId, true);
                        }
                        return _ctx.abrupt("return");
                    case 15:
                        contentElement = document.getElementById("reply-content-container");
                        if (contentElement) {
                            contentElement.scrollTo({
                                top: contentElement.scrollHeight
                            });
                        }
                        _ctx.next = 20;
                        break;
                    case 19:
                        {
                            // reset parent state
                            onCancel();
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleInitialLoad() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (postId) {
            handleInitialLoad();
            // reset convo compose reply box
            // if open another conversation
            setRepliedComment(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        postId
    ]);
    var activeStream = selected || {};
    var handleLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(lastReplyPostId) {
            var autoScroll, request, getPrevConvo, _payload, data, error, commentElement, ref, commentElement1, contentElement, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        autoScroll = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        request = {
                            lastReplyPostId: lastReplyPostId,
                            postid: postId
                        };
                        _ctx.next = 4;
                        return dispatch(StreamConversation_slice/* effects.loadPreviousConversation */.Sz.loadPreviousConversation(request));
                    case 4:
                        getPrevConvo = _ctx.sent;
                        _payload = getPrevConvo.payload, data = _payload.data, error = _payload.error;
                        if (error) {
                            _ctx.next = 24;
                            break;
                        }
                        setLoadMore(data.more);
                        if (!(autoScroll === true)) {
                            _ctx.next = 23;
                            break;
                        }
                        commentElement = document.getElementById("convo-".concat(activeCommentId));
                        if (!commentElement) {
                            _ctx.next = 14;
                            break;
                        }
                        {
                            scrollToComment(activeCommentId);
                            setHasAutoLoad(false);
                        }
                        _ctx.next = 21;
                        break;
                    case 14:
                        if (!data.more) {
                            _ctx.next = 20;
                            break;
                        }
                        ;
                        _ctx.next = 18;
                        return handleLoadMore((ref = data === null || data === void 0 ? void 0 : data.replies[0]) === null || ref === void 0 ? void 0 : ref.postid, true);
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        {
                            setHasAutoLoad(false);
                        }
                    case 21:
                        _ctx.next = 24;
                        break;
                    case 23:
                        {
                            commentElement1 = document.getElementById("convo-".concat(lastReplyPostId));
                            contentElement = document.getElementById("reply-content-container");
                            contentElement.scrollTo({
                                top: commentElement1.offsetTop
                            });
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMore(lastReplyPostId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReplyComment = function(reply) {
        setRepliedComment(reply);
    };
    var handleComposeConversation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var ref, data, compose, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), {
                            parent: activeStream === null || activeStream === void 0 ? void 0 : (ref = activeStream.parent) === null || ref === void 0 ? void 0 : ref.postid
                        });
                        _ctx.next = 4;
                        return dispatch(entities_stream/* effects.postConversationStream */.Sz.postConversationStream(data));
                    case 4:
                        compose = _ctx.sent;
                        error = compose.payload.error;
                        if (!error) {
                            setRepliedComment(null);
                        }
                        return _ctx.abrupt("return", !error);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleComposeConversation(val) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelCompose = function() {
        setRepliedComment(null);
    };
    var isLoading = isLoadingInitial || isLoadingMore && hasAutoLoad;
    var tmp = activeStream.is_commentable, isCommentable = tmp === void 0 ? false : tmp;
    var isAuthorDetailPost = Boolean(activeStream === null || activeStream === void 0 ? void 0 : (ref = activeStream.parent) === null || ref === void 0 ? void 0 : ref.is_author);
    var ref11 = (0,_sliced_to_array/* default */.Z)(hooks_useStreamConversationModal(), 2), detailWidth = ref11[0], detailHeight = ref11[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalReply, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        visible: visible,
        closable: false,
        centered: true,
        width: "100%",
        mask: false,
        footer: null,
        wrapClassName: "modal-conversation",
        bodyStyle: {
            height: "100vh",
            padding: "0"
        },
        transitionName: "",
        maskTransitionName: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation_DetailStream, {
                    post: (activeStream === null || activeStream === void 0 ? void 0 : activeStream.parent) || {},
                    topics: (activeStream === null || activeStream === void 0 ? void 0 : activeStream.since_message) || [],
                    onCancel: onCancel,
                    isLoading: isLoading,
                    handleClose: onCancel,
                    dimension: {
                        width: detailWidth,
                        height: detailHeight
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReplyContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReplyListContainer, {
                            id: "reply-content-container",
                            children: [
                                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyContent, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamSkeleton, {})
                                }),
                                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !hasLoadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyContent, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation_ItemConversation, {
                                                post: activeStream.parent,
                                                onComment: handleReplyComment,
                                                showCommentLimitInfo: (activeStream === null || activeStream === void 0 ? void 0 : (ref1 = activeStream.parent) === null || ref1 === void 0 ? void 0 : ref1.is_author) !== 0,
                                                handleClose: onCancel,
                                                type: "post",
                                                isAuthorDetailPost: isAuthorDetailPost
                                            })
                                        }, "main-post-".concat((ref2 = activeStream.parent) === null || ref2 === void 0 ? void 0 : ref2.postid)),
                                        hasLoadMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamConversation_Flex, {
                                            direction: "column",
                                            width: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadConvoButton, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamConversation_Text, {
                                                        as: "a",
                                                        color: ui/* color.primary */.$_.primary,
                                                        onClick: function() {
                                                            var ref;
                                                            // @ts-ignore
                                                            var lastReplyPostId = (ref = selected === null || selected === void 0 ? void 0 : selected.replies[0]) === null || ref === void 0 ? void 0 : ref.postid;
                                                            handleLoadMore(lastReplyPostId, false);
                                                        },
                                                        children: [
                                                            isLoadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                                                style: {
                                                                    marginRight: "12px"
                                                                }
                                                            }),
                                                            "Load Previous Conversation"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_LoaderBar, {
                                                    isLoading: isLoadingMore
                                                })
                                            ]
                                        }, "load-more-".concat((ref3 = activeStream.parent) === null || ref3 === void 0 ? void 0 : ref3.postid)),
                                        activeStream === null || activeStream === void 0 ? void 0 : (ref4 = activeStream.replies) === null || ref4 === void 0 ? void 0 : ref4.map(function(reply) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyContent, {
                                                isSelected: Number(activeCommentId) === reply.postid,
                                                id: "convo-".concat(reply.postid),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation_ItemConversation, {
                                                    post: reply,
                                                    type: "comment",
                                                    onComment: handleReplyComment,
                                                    handleClose: onCancel,
                                                    isAuthorDetailPost: isAuthorDetailPost
                                                })
                                            }, reply.postid);
                                        })
                                    ]
                                })
                            ]
                        }),
                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConvoSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isCommentable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation_ComposeConversation, {
                                repliedComment: repliedComment,
                                onSubmit: handleComposeConversation,
                                onCancel: handleCancelCompose,
                                isLoading: isLoadingCompose,
                                avatar: avatar,
                                username: username
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposeConversation_ComposeLimited, {})
                        })
                    ]
                })
            ]
        })
    }));
}
StreamConversation.defaultProps = {
    onCancel: function() {},
    postId: 0,
    parentId: 0,
    visible: false,
    activeCommentId: 0,
    openConversation: function() {}
};
/* harmony default export */ var global_StreamConversation = (StreamConversation);


/***/ }),

/***/ 61048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25641);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51679);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14601);
/* harmony import */ var _StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47225);









// APIs
// External reducer

var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_LIKED = 1;
var STATUS_UNLIKED = 0;
var initialState = {
    data: {},
    selected: {},
    isLoading: true,
    isLoadingMore: false,
    error: null,
    message: ""
};
// Selectors -----------------------------------------------------------
var convoSelector = function(state) {
    return state.streamConversation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(convoSelector, function(convo) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, convo);
});
// Action type -----------------------------------------------------------
var CONTEXT = "@redux/streamConversation";
var actionType = {
    GET_CONVERSATION: "".concat(CONTEXT, "/GET_CONVERSATION"),
    LOAD_PREV_CONVERSATION: "".concat(CONTEXT, "/LOAD_PREV_CONVERSATION")
};
var // Helper -----------------------------------------------------------
IActionStatus;
(function(IActionStatus) {
    IActionStatus[IActionStatus["STATUS_FOLLOWING"] = 0] = "STATUS_FOLLOWING";
    IActionStatus[IActionStatus["STATUS_UNFOLLOWING"] = 1] = "STATUS_UNFOLLOWING";
    IActionStatus[IActionStatus["STATUS_SAVED"] = 2] = "STATUS_SAVED";
    IActionStatus[IActionStatus["STATUS_UNSAVED"] = 3] = "STATUS_UNSAVED";
    IActionStatus[IActionStatus["STATUS_LIKED"] = 4] = "STATUS_LIKED";
    IActionStatus[IActionStatus["STATUS_UNLIKED"] = 5] = "STATUS_UNLIKED";
})(IActionStatus || (IActionStatus = {}));
/**
 * Do Count of Stream Post Likes
 * @param state state
 * @param status status
 */ var countStreamPostLike = function(state, status) {
    if (status === STATUS_LIKED) {
        state.likes += 1;
    } else if (status === STATUS_UNLIKED) {
        state.likes -= 1;
    }
};
/**
 * Change Status of Action
 * @param state state object
 * @param postid post id
 * @param action property that want to change
 * @param status value that you want to apply to the property
 * @description
 * this for change follow, saved, liked, likes value
 * from state.selected
 */ var changeActionStatus = function(state, postid, action, status) {
    var ref, ref1, ref2;
    // check index of replies item of selected convo
    var replyIdx = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(reply) {
        return reply.postid === postid;
    });
    // change 'action' value of replies item with status
    if (replyIdx > -1) {
        state.selected.replies[replyIdx][action] = status;
        if (action === "liked") {
            countStreamPostLike(state.selected.replies[replyIdx], status);
        }
    } else if (((ref2 = state.selected.parent) === null || ref2 === void 0 ? void 0 : ref2.postid) === postid) {
        state.selected.parent[action] = status;
        if (action === "liked") {
            countStreamPostLike(state.selected.parent, status);
        }
    }
};
// Effects -----------------------------------------------------------
var effects = {
    getStreamConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var postId, parentId, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postId = param.postId, parentId = param.parentId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStreamConversation */ .Z.getStreamConversation({
                            postId: postId,
                            parentId: parentId
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 7:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformConversationV3 */ .PI)(posts.conversation);
                        return _ctx.abrupt("return", {
                            postid: postId,
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadPreviousConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.LOAD_PREV_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var ref, lastReplyPostId, postid, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        lastReplyPostId = params.lastReplyPostId, postid = params.postid;
                        _ctx.next = 5;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getPrevStreamConversation */ .Z.getPrevStreamConversation(lastReplyPostId);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 8:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        data = {
                            more: !((ref = posts.pagination) === null || ref === void 0 ? void 0 : ref.is_last_page),
                            replies: (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformV3Response */ .bv)(posts.stream)
                        };
                        return _ctx.abrupt("return", {
                            postid: postid,
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers -----------------------------------------------------------
var reducers = {
    closeStreamConversation: function(state) {
        state.isLoading = initialState.isLoading;
        state.isLoadingMore = initialState.isLoadingMore;
    }
};
// Extra reducers -----------------------------------------------------------
var extraReducers = function(builder) {
    builder.addCase(effects.getStreamConversation.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getStreamConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = data;
            state.error = null;
            state.isLoading = false;
        }
        state.message = message;
    }).addCase(effects.getStreamConversation.rejected, function(state, action) {
        state.error = action.payload.error;
    }).addCase(effects.loadPreviousConversation.pending, function(state) {
        state.isLoadingMore = true;
        state.error = null;
    }).addCase(effects.loadPreviousConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state.selected), {
                // @ts-ignore
                replies: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(data.replies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(state.selected.replies)),
                more: data.more
            });
            state.error = null;
        }
        state.isLoadingMore = false;
        state.message = message;
    }).addCase(effects.loadPreviousConversation.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoadingMore = false;
    })// Follow/unfollow stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.followPost.fulfilled */ .Sz.followPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_FOLLOWING);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unfollowPost.fulfilled */ .Sz.unfollowPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_UNFOLLOWING);
    })// Save/unsave stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.savePost.fulfilled */ .Sz.savePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_SAVED);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unsavePost.fulfilled */ .Sz.unsavePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_UNSAVED);
    })// Like/unline stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.likePost.fulfilled */ .Sz.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_LIKED);
        }
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unlikePost.fulfilled */ .Sz.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_UNLIKED);
        }
    })// When conversation success replied, the response will be added
    // as new reply to the state.data
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.postConversationStream.fulfilled */ .Sz.postConversationStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            // @ts-ignore
            var replies = state.selected.replies;
            var newReplies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(replies).concat([
                data
            ]);
            // @ts-ignore
            state.selected.replies = newReplies;
        }
    })// When conversation reply success replied, the reply item state
    // will be updated with api response
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.updatePostStream.fulfilled */ .Sz.updatePostStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        var isReply = (data === null || data === void 0 ? void 0 : data.postid) !== (data === null || data === void 0 ? void 0 : data.parent_postid);
        if (data) {
            var ref;
            // @ts-ignore
            if (isReply && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.replies)) {
                var _arg = action.meta.arg, commenterType = _arg.commenter_type;
                // @ts-ignore
                var replies = state.selected.replies;
                var idxReplies = replies.findIndex(function(reply) {
                    return (reply === null || reply === void 0 ? void 0 : reply.postid) === (data === null || data === void 0 ? void 0 : data.postid);
                });
                if (idxReplies > -1) {
                    // Update reply item
                    // update created using old and updated as created we receive from server
                    var newReplies = replies;
                    var currentComment = newReplies[idxReplies];
                    newReplies[idxReplies] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                        commenter_type: commenterType,
                        created: currentComment.created,
                        created_display: currentComment.created_display,
                        updated: data === null || data === void 0 ? void 0 : data.created
                    });
                    // @ts-ignore
                    state.selected.replies = newReplies;
                }
            }
        }
    })// When stream post detail/conversation change the comment limitation
    // it will update the commenter_type of parent stream post
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.changeCommenter.fulfilled */ .Sz.changeCommenter.fulfilled, function(state, action) {
        var ref;
        var error = action.payload.error;
        var type = action.meta.arg.type;
        // @ts-ignore
        if (!error && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.parent)) {
            // @ts-ignore
            state.selected.parent.commenter_type = type;
        }
    })// Handle sideeffect when user post polling vote on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVotePolling.fulfilled */ .Sz.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            var selectedParent = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.polling;
            if (selectedParent) {
                var ref2;
                if (selectedParent.length > 0 && ((ref2 = selectedParent[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === data.id) {
                    // @ts-ignore
                    state.selected.parent.polling[0] = data;
                }
            }
        }
    })// Handle sideeffect when user click price target action on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVoteTargetPrice.fulfilled */ .Sz.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            if (((ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.postid) === data.postid) {
                // @ts-ignore
                state.selected.parent = data;
            }
        }
    });
};
var streamConversation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "streamConversation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (streamConversation);


/***/ })

}]);